import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Icon } from "@evergis/ui";

import { DropdownOption, DropdownOptionExtraContainer, DropdownOptionExtraIconContainer } from "../styled";

import { useTableActiveLayers } from "./useTableActiveLayers";
import { useActiveLayersCounts } from "./useActiveLayersCounts";
import { getTableFilterConditions } from "../../../ducks/table/selectors";
import { useGeometrySelectionConditions } from "../../../hooks/geometrySelection/useGeometrySelectionConditions";

export const useTableLayersOptions = () => {
  const { t } = useTranslation("table");
  const tableActiveLayers = useTableActiveLayers();
  const layersFilteredCount = useActiveLayersCounts();
  const tableFilterConditions = useSelector(getTableFilterConditions);
  const geometrySelectionConditions = useGeometrySelectionConditions();

  return useMemo(() => {
    return tableActiveLayers.map(item => {
      const currentCount = layersFilteredCount?.[item.name] ?? item.objectCount;
      const hasLayerCondition = Boolean(item.condition);
      const hasTableFilters = Boolean(tableFilterConditions?.[item.name]);
      const hasGeometrySelection = Boolean(geometrySelectionConditions?.[item.name]);

      return {
        text: <DropdownOption isVisible={item.isVisible}>{item.alias || item.name}</DropdownOption>,
        value: item.name,
        description: (
          <DropdownOption isVisible={item.isVisible}>
            {t("total")} {currentCount} {t("of")} {item.objectCount || 0}
          </DropdownOption>
        ),
        suffix: (
          <DropdownOptionExtraContainer>
            <DropdownOptionExtraIconContainer>
              <Icon kind="layer_filter_applied" primary={hasLayerCondition} disabled={!hasLayerCondition} />
            </DropdownOptionExtraIconContainer>
            <DropdownOptionExtraIconContainer>
              <Icon kind="attribute_filter_applied" primary={hasTableFilters} disabled={!hasTableFilters} />
            </DropdownOptionExtraIconContainer>
            <DropdownOptionExtraIconContainer>
              <Icon kind="geometry_selection_applied" primary={hasGeometrySelection} disabled={!hasGeometrySelection} />
            </DropdownOptionExtraIconContainer>
          </DropdownOptionExtraContainer>
        ),
      };
    });
  }, [tableActiveLayers, layersFilteredCount, tableFilterConditions, geometrySelectionConditions, t]);
};
